import React, { useState, useEffect } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import subsidiaryCompanyCompletionsService from '../charts/subsidiary_company_completions.service';
const SubsidiaryCompanyCompletionTable = _ref => {
  let {
    filteredBusinessUnits,
    selectedYears,
    companyId,
    selectedSubsidiaryCompanyIds
  } = _ref;
  const {
    t
  } = useTranslation();
  const [chartData, setChartData] = useState([]);
  const grey = '#666E7E';
  useEffect(() => {
    const fetchData = async () => {
      try {
        const businessUnitsParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
        const yearsParam = selectedYears.join(',');
        const subsidiaryCompanyIdsParam = selectedSubsidiaryCompanyIds.join(',');
        const data = await subsidiaryCompanyCompletionsService.all(companyId, businessUnitsParam, yearsParam, subsidiaryCompanyIdsParam);
        setChartData(data);
      } catch (error) {
        console.error('Error fetching Secure QE data by subsidiary company:', error);
      }
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedYears, selectedSubsidiaryCompanyIds]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-business-unit-table-container",
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    style: {
      borderCollapse: 'separate',
      borderSpacing: '0 8px'
    }
  }, /*#__PURE__*/React.createElement("thead", {
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement("th", null, t('Company')), /*#__PURE__*/React.createElement("th", null, t('Project Completion')), /*#__PURE__*/React.createElement("th", null, t('Cost Completion')))), /*#__PURE__*/React.createElement("tbody", {
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, chartData.map(item => /*#__PURE__*/React.createElement("tr", {
    key: item.subsidiary_name,
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    }
  }, item.subsidiary_name), /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    }
  }, item.completion_percentage, /*#__PURE__*/React.createElement("span", null, "%")), /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    }
  }, item.positive_cost_percentage, /*#__PURE__*/React.createElement("span", null, "%")))), chartData.length === 0 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    },
    colSpan: 3,
    className: "text-center"
  }, t('No data'))))));
};
export default SubsidiaryCompanyCompletionTable;